// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-template-wrapper-container {
  padding: 0px 16px 5px 16px;
  display: inline-block;
  width: 100%;
}
.form-template-wrapper-container .form-temp-content {
  border-radius: 4px 0px 0px 0px;
  background: var(--form-temp-bg);
  display: flex;
  width: 100%;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
}
.form-template-wrapper-container .form-temp-content h1 {
  color: var(--form-temp--text-color);
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.form-template-wrapper-container .form-temp-content .form-input-wrapper {
  width: 100%;
}
.form-template-wrapper-container .form-temp-content .form-input-wrapper label {
  color: var(--form-temp--text-color);
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  width: 100%;
  display: block;
  margin-bottom: 4px;
}
.form-template-wrapper-container .form-temp-content .form-input-wrapper input {
  width: 100%;
  display: flex;
  height: 40px;
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid var(--sdk-gloabl-border-color);
  background: var(--form-temp-input-bg);
  box-shadow: var(--form-temp-input-box-shadow);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: var(--form-temp--text-color);
}
.form-template-wrapper-container .form-temp-content .form-input-wrapper input::placeholder {
  color: var(--form-temp-input-placeholder);
  opacity: 0.5;
}
.form-template-wrapper-container .form-temp-content .btn-group {
  display: flex;
  gap: 8px;
  align-items: center;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/templatemanager/templates/formTemplate/formTemplate.scss"],"names":[],"mappings":"AACA;EACI,0BAAA;EACA,qBAAA;EACA,WAAA;AAAJ;AACI;EACI,8BAAA;EACA,+BAAA;EACA,aAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;AACR;AAAQ;EACI,mCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAEZ;AAAQ;EACI,WAAA;AAEZ;AADY;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;AAGhB;AADY;EACI,WAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,gDAAA;EACA,qCAAA;EACA,6CAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mCAAA;AAGhB;AAFgB;EACI,yCAAA;EACA,YAAA;AAIpB;AAAQ;EACI,aAAA;EACA,QAAA;EACA,mBAAA;EACA,WAAA;AAEZ","sourcesContent":["\n.form-template-wrapper-container{\n    padding: 0px 16px 5px 16px;\n    display: inline-block;\n    width: 100%;\n    .form-temp-content{\n        border-radius: 4px 0px 0px 0px;\n        background: var(--form-temp-bg);\n        display: flex;\n        width: 100%;\n        padding: 16px;\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 12px;\n        h1{\n            color: var(--form-temp--text-color);\n            font-size: 14px;\n            font-style: normal;\n            font-weight: 700;\n            line-height: normal;\n        }\n        .form-input-wrapper{\n            width: 100%;\n            label{\n                color: var(--form-temp--text-color);\n                font-size: 14px;\n                font-weight: 500;\n                line-height: 20px;\n                width: 100%;\n                display: block;\n                margin-bottom: 4px;\n            }\n            input{\n                width: 100%;\n                display: flex;\n                height: 40px;\n                padding: 8px 12px;\n                border-radius: 6px;\n                border: 1px solid var(--sdk-gloabl-border-color);\n                background: var(--form-temp-input-bg);\n                box-shadow: var(--form-temp-input-box-shadow);\n                font-size: 14px;\n                font-weight: 400;\n                line-height: 20px;\n                color: var(--form-temp--text-color);\n                &::placeholder{\n                    color: var(--form-temp-input-placeholder);\n                    opacity: 0.5;\n                }\n            }\n        }\n        .btn-group{\n            display: flex;\n            gap: 8px;\n            align-items: center;\n            width: 100%;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
